import * as api from './EntityApi';
import { getNamespace } from '../../utils/storage';
import { GET_ENTITY_CHOICES } from './EntityType';
const reportFormat = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet';

export const getAnEntityReportsAction =
    (item, service = api.getAnEntityReports) =>
    async (dispatch) => {
        const namespace = getNamespace();
        return await service(item.key, namespace).then((response) => {
            const url = URL.createObjectURL(
                new Blob([response.data], {
                    type: reportFormat
                })
            );
            dispatch({
                type: `GET_${item.key.toUpperCase()}_ENTITY`,
                payload: url
            });
            return url;
        });
    };
export const getEntityChoices =
    (service = api.getEntityChoices) =>
    async (dispatch) => {
        dispatch({
            type: GET_ENTITY_CHOICES.REQUEST
        });
        const namespace = getNamespace();
        return await service(namespace)?.then((response) => {
            dispatch({
                type: GET_ENTITY_CHOICES.SUCCESS,
                payload: response.data.entities
            });
        });
    };
